import ImagesIconsNotificationsAskSvg from '@/public/images/icons/notifications/ask.svg';
import ImagesIconsNotificationsBidSvg from '@/public/images/icons/notifications/bid.svg';
import ImagesIconsNotificationsCalendarSvg from '@/public/images/icons/notifications/calendar.svg';
import ImagesIconsNotificationsErrorSvg from '@/public/images/icons/notifications/error.svg';
import ImagesIconsNotificationsExpireSvg from '@/public/images/icons/notifications/expire.svg';
import ImagesIconsNotificationsMatchSvg from '@/public/images/icons/notifications/match.svg';
import ImagesIconsNotificationsNewSvg from '@/public/images/icons/notifications/new.svg';

export {
  ImagesIconsNotificationsAskSvg,
  ImagesIconsNotificationsBidSvg,
  ImagesIconsNotificationsCalendarSvg,
  ImagesIconsNotificationsErrorSvg,
  ImagesIconsNotificationsExpireSvg,
  ImagesIconsNotificationsMatchSvg,
  ImagesIconsNotificationsNewSvg,
};
